


export const formatPct = (value) => { if (value != null) return `${Math.trunc(value)}%` }


export const HEADER_TEXT = {
    title: "Where visibility is limited",
    description: "Behaviors most frequently marked as \"Can't Answer\" by stakeholders."
}